import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { RouterProvider } from 'react-router';
import router from './Router/Router';
import store from './App/Store'
import { Provider } from 'react-redux'
import axios from './Axios/Default';
import { DoRefreshToken } from './Services/AuthServices';
import { jwtDecode } from "jwt-decode";
import { config } from '@fortawesome/fontawesome-svg-core';
import { DoRefreshTokenAdmin } from './Services/Admin/AuthAdminSevices';


const root = ReactDOM.createRoot(document.getElementById('root'));

// axios.interceptors.request.use(
//   config => {

//     console.log('add refresh token here')
//     // const token = localStorage.getItem('auth_token');
//     // if (token) {
//     //     config.headers['Authorization'] = 'Bearer ' + token;
//     // }
//     // config.headers['Content-Type'] = 'application/json';
//     return config;
//   },
//   error => {
//     Promise.reject(error)
//   });
let isOnRefresh = false;
let failedQueue = [];
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

axios.interceptors.request.use(
  async (config) => {
    let access_token = localStorage.getItem("access_token");
    let access_token_admin = localStorage.getItem("access_token_admin");
    // alert('asd')

    if (access_token) {
        
      const decodedToken = jwtDecode(access_token);
      const tokenExpirationTime = decodedToken.exp * 1000; 
      const refreshInterval = 5 * 60 * 1000;
      const currentTime = Date.now();
      const timeUntilExpiration = tokenExpirationTime - currentTime;
      // alert('ad')
      if (!config.url.includes("login") && !config.url.includes("refresh-token")) {

        config.headers['Authorization'] = 'Bearer ' + access_token;

        if (timeUntilExpiration <= refreshInterval && !isOnRefresh) {
          isOnRefresh = true;
          var data = new FormData();
          data.append("refresh_token", localStorage.getItem("refresh_token"));

          await DoRefreshToken(data).then((response) => {

            if (response.status == 200) {
              localStorage.setItem("access_token", response.data.access_token);
              localStorage.setItem("refresh_token", response.data.refresh_token);
              localStorage.setItem("xsrf_token", response.data.xsrf_token);
              localStorage.setItem("username", response.data.username);
              localStorage.setItem("stasion_id", response.data.station_id);

              axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access_token}`;
              config.headers.Authorization = `Bearer ${response.data.access_token}`;
              processQueue(null, response.data.access_token);

            } else {
              localStorage.clear();
              console.log('session berakhir')
            }
          }).catch((errorRefresh) => {
            console.log('config.url', errorRefresh.response.data.message)

            if (errorRefresh.response.data.status == 401 && (errorRefresh.response.data.message == 'Expired token' || errorRefresh.response.data.message == 'Signature verification failed' || errorRefresh.response.data.message == 'Invalid refresh token!')) {
              localStorage.clear();
              window.location.href = '/monitoring/login';
            }
          }).finally(() => {
            isOnRefresh = false;
          });
        }
      }
    }else if(access_token_admin){
      
      const decodedToken = jwtDecode(access_token_admin);
      const tokenExpirationTime = decodedToken.exp * 1000; 
      const refreshInterval = 5 * 60 * 1000;
      const currentTime = Date.now();
      const timeUntilExpiration = tokenExpirationTime - currentTime;
      
      if (!config.url.includes("admin/login") && !config.url.includes("/admin/refresh-token")) {

        config.headers['Authorization'] = 'Bearer ' + access_token_admin;
        if (timeUntilExpiration <= refreshInterval && !isOnRefresh) {
          // alert('asd')
          
          var data = new FormData();
          data.append("refresh_token", localStorage.getItem("refresh_token_admin"));
          
          try {
            await DoRefreshTokenAdmin(data).then((response) => {
              console.log('response', response);
            });
          } catch (error) {
            window.location.href = 'admin/login';
          }

        
        }
      }

    }

    return config;
  },
  (error) => {
    // console.log('error',error)
    alert('asds')
    if (error.response && error.response.status === 401) {
      window.location.href = '/monitoring/login';
    }
    return Promise.reject(error);
  }
);





root.render(
  <Provider store={store}>

    <RouterProvider router={router} />
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
